import { render, staticRenderFns } from "./DashboardBounceRate.vue?vue&type=template&id=61c312fd&scoped=true&"
import script from "./DashboardBounceRate.vue?vue&type=script&lang=js&"
export * from "./DashboardBounceRate.vue?vue&type=script&lang=js&"
import style0 from "./DashboardBounceRate.vue?vue&type=style&index=0&id=61c312fd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c312fd",
  null
  
)

export default component.exports